/**
 * <sticky-offer-bar> - shows a fixed bottom bar once the real offer selector
 * has scrolled out of view; clicking it scrolls back up to it. Uses
 * IntersectionObserver (viewport-relative) rather than window.scrollY, since
 * some themes scroll an inner wrapper instead of the window itself.
 */
class StickyOfferBar extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', () => this.scrollToOffer());

    this.target = document.querySelector('.offer-selector');
    if (!this.target) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    this.observer.observe(this.target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  scrollToOffer() {
    this.target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('sticky-offer-bar')) {
  customElements.define('sticky-offer-bar', StickyOfferBar);
}
